import { Box, Stack } from "@mui/material";
import { useLocation } from "react-router-dom";
import { SMART_CHARGING_PATHS } from "src/consts/paths";
import PageTitle from "src/components/Displays/PageTitle";
import { SMART_CHARGING_ROUTES } from "src/consts/routes";
import PageSubTitle from "src/components/Displays/PageSubTitle";
import VerticalLinearProgress from "src/components/ProgressBar/VerticalLinearProgressBar";

export const tariffCalculator = (pathname: string) => {
  switch (pathname) {
    case SMART_CHARGING_ROUTES.TERMS:
      return 55;
    case SMART_CHARGING_ROUTES.COMPATIBILITY_SUCCESS:
      return 90;
    default:
      return 20;
  }
};

const SmartChargingCompatibilityProgressBar = () => {
  const { pathname } = useLocation();

  return (
    <Stack
      gap="13px"
      sx={{
        display: { xs: "none", sm: "flex" },
      }}
    >
      <PageTitle text={"Menü"} />
      {SMART_CHARGING_PATHS.includes(pathname) && (
        <Box
          sx={{
            gap: 3,
            height: 90,
            display: { xs: "flex", sm: "default" },
          }}
        >
          <VerticalLinearProgress
            variant="determinate"
            value={90 - tariffCalculator(pathname)}
          />
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              gap: "16px",
            }}
          >
            <PageSubTitle text={"Wallbox"} />
            <PageSubTitle text={"AGB"} />
            <PageSubTitle text={"Status"} />
          </Box>
        </Box>
      )}
    </Stack>
  );
};

export default SmartChargingCompatibilityProgressBar;
